function initializeCommentsLazyLoad() {
  const trigger = document.getElementById('comments-more');
  if (!trigger) return;

  const url = trigger.dataset.commentsUrl;
  if (!url) return;

  const list = document.getElementById('comments-list');
  if (!list) return;

  let loaded = false;

  function loadMoreComments() {
    if (loaded) return;
    loaded = true;

    fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to load comments');
        return response.text();
      })
      .then(function(html) {
        trigger.outerHTML = html;
      })
      .catch(function() {
        trigger.innerHTML = '<span class="comments-loading">Could not load remaining comments.</span>';
      });
  }

  const observer = new IntersectionObserver(
    function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          loadMoreComments();
          observer.disconnect();
        }
      });
    },
    { rootMargin: '200px' }
  );

  observer.observe(trigger);
}

document.addEventListener('DOMContentLoaded', initializeCommentsLazyLoad);
document.addEventListener('turbolinks:load', initializeCommentsLazyLoad);
